import React from 'react';
import MobileSubmitLayout from '../MobileSubmitLayout';
import ImagePreviewWithDisplayOptions from '../../common/ImagePreviewWithDisplayOptions';
import TitleField from '../../../fields/TitleField';
import DescriptionField from '../../../fields/DescriptionField';
import ApplicationFieldsGroup from '../../../fields/ApplicationFieldsGroup';
import GallerySelectField from '../../../fields/GallerySelectField';
import GroupSelectField from '../../../fields/GroupSelectField';
import PremiumGalleryField from '../../../fields/PremiumGalleryField';
import DisableCommentsField from '../../../fields/DisableCommentsField';

interface Props {}

const ApplicationSubmitForm: React.FC<Props> = () => {
  return (
    <MobileSubmitLayout preview={<ImagePreviewWithDisplayOptions compact />}>
      <TitleField />
      <DescriptionField />
      <ApplicationFieldsGroup />
      <GallerySelectField />
      <GroupSelectField />
      <PremiumGalleryField />
      <DisableCommentsField />
    </MobileSubmitLayout>
  );
};
ApplicationSubmitForm.displayName = 'ApplicationSubmitForm';

export default ApplicationSubmitForm;
